export const theme = {
  primary: '#FFD001',
  primaryDark: '#E6BE2E',
  primaryLight: '#FFF3C4',

  black: '#111111',
  blackSoft: '#1A1A1A',

  darkGray: '#2E2E2E',
  mediumGray: '#3A3A3A',
  lightGray: '#E5E5E5',

  background: '#FAFAFA',
  surface: '#FFFFFF',
  border: '#E5E7EB',

  success: '#6B8E23',
  warning: '#D97706',
  error: '#B91C1C',

  textPrimary: '#111111',
  textSecondary: '#3A3A3A',
  textMuted: '#737373',
  textInverted: '#FFFFFF'
};
